import React, { Component } from 'react';
import { DoctorInput, RecordHistory } from '../../../utils/components';
import { CallAPI, parseIntFromStr } from '../../../utils/util';
import { PatientNav } from '../../patients/patientnav';
import {useLocation, useNavigate, useParams} from "react-router-dom";

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();

        return (
            <Component
                {...props}
                router={{ location, navigate, params }}
            />
        );
    }
    return ComponentWithRouterProp;
}

class TreatmentNotes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patientID: parseIntFromStr(this.props.router.params.patientId),
            history: [],
            step: parseIntFromStr(this.props.router.params.step)
        }
        this.submit = this.submit.bind(this)
    }

    submit() {
        CallAPI(this.state, `patients/${this.state.patientID}/treatmentNotes`, 'PUT', (res) => {
            this.props.router.navigate(`/patients/${this.state.patientID}/profile`)
        })
    }

    getRes() {
        var link = ""
        switch (this.state.step) {
            case 1:
                link = `patients/${this.state.patientID}/labReports/bp`
                break;
            case 2:
                link = `patients/${this.state.patientID}/labReports/va`
                break;
            case 3:
                link = `patients/${this.state.patientID}/labReports/da`
                break;
            case 4:
                link = `patients/${this.state.patientID}/labReports/aa`
                break;
            case 5:
                link = `patients/${this.state.patientID}/labReports/am`
                break;
            case 6:
                link = `patients/${this.state.patientID}/labReports/bmm`
                break;
            case 7:
                link = `patients/${this.state.patientID}/labReports/na`
                break;
            case 8:
                return;
            default:
                this.setState({"step": 7})
                link = `patients/${this.state.patientID}/labReports/na`
                break;
        }
        CallAPI({}, link, 'GET', (res) => {
            this.setState({"history": res});
        })
    }

    componentDidMount() {
        this.getRes()
    }

    render = () => {
        const pid = this.state.patientID;
        const step = this.state.step;

        const stepTitles = {
            1: "Blood Pressure",
            2: "Volume Assessment",
            3: "Dialysis Adequacy",
            4: "Access Assessment",
            5: "Anemia Management",
            6: "Bone Mineral Management",
            7: "Nutrition Assessment",
            8: "Signature"
        };

        const stepRadios = {
            1: ["Stable", "High", "Low"],
            2: ["High Weight Gain", "Optimal Weight Gain", "Dry Weight Adjusted"],
            3: ["Target Met", "Target Not Met"],
            4: ["Access Reviewed", "New Access Developing - Awaiting Use", "Catheter"],
            5: ["Anemia Reviewed", "ESA Adjusted Per Protocol"],
            6: ["BMM Labs Reviewed", "Phosphate Binders Adjusted", "Vitamin D Adjusted"],
            7: ["Nutrition Reviewed", "Potassium Controlled", "Potassium High"]
        };

        const stepTableTypes = {
            1: ["Blood Pressure"],
            2: ["Dry Weight", "Deviation"],
            3: ["spKt/V", "URR"],
            4: ["Flow"],
            5: ["Hemoglobin", "Micera", "Iron"],
            6: ["Phosphorus", "Calcium", "PTH"],
            7: ["Albumin", "Potassium"]
        };

        if (step === 8) {
            return (
                <div>
                    <PatientNav patientId={pid} />
                    <div className="ci-page">
                        <div className="ci-header">
                            <h2>Signature</h2>
                            <p>Step {step} of 8 — Confirm and sign treatment notes</p>
                        </div>
                        <div className="ci-card" style={{ textAlign: 'center', padding: '40px 20px' }}>
                            <p style={{ marginBottom: '24px', color: 'var(--text-secondary)' }}>
                                Review complete. Click below to sign and submit your treatment notes.
                            </p>
                            <div className="tn-nav-buttons">
                                <a href="." className="homeButton" onClick={(e) => { e.preventDefault(); this.setState({ step: step - 1 }, this.getRes); }}>
                                    ← Back
                                </a>
                                <button type="button" className="logSubmit" style={{ width: 'auto', marginTop: 0 }} onClick={this.submit}>
                                    Verify &amp; Sign
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        if (step < 1 || step > 7) return <div />;

        return (
            <div>
                <PatientNav patientId={pid} />
                <div className="ci-page">
                    <div className="ci-header">
                        <h2>{stepTitles[step]}</h2>
                        <p>Step {step} of 8 — Treatment Notes</p>
                    </div>
                    <RecordHistory table={this.state.history} tableType={stepTableTypes[step]} />
                    <DoctorInput radios={stepRadios[step]} component={this} first={step === 1} />
                </div>
            </div>
        );
    }
}

export default withRouter(TreatmentNotes)